import Navbar from "../general/navbar";
import Learning from "../awakening/learning";
import Programme from "../awakening/programme";
import ImageCarousel from "../general/imageCarousel";
import Footer from "../general/footer";
export default function IndexPage() {
  return (
    <div className="awakening-page">
      <Navbar />
      <Learning />
      <Programme />
      <ImageCarousel />
      <Footer />
    </div>
  );
}
